var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "OrderCount",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-order-count","viewBox":"0 0 100 100"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M24.947 38.082v23.259l26.261 8.596 23.845-8.565V37.589l-23.065 7.567a1.451 1.451 0 0 1-.833.023l-26.208-7.097zm.906-2.882l25.642 6.943 21.838-7.165-22.116-4.966L25.853 35.2zM50 100C22.386 100 0 77.614 0 50S22.386 0 50 0s50 22.386 50 50-22.386 50-50 50zm0-4c25.405 0 46-20.595 46-46S75.405 4 50 4 4 24.595 4 50s20.595 46 46 46zm1.23-23c-.153 0-.306-.024-.453-.073L23.02 63.842A1.49 1.49 0 0 1 22 62.425V34.168c0-.709.494-1.32 1.182-1.461l27.757-5.679a1.51 1.51 0 0 1 .611.006l25.296 5.679A1.488 1.488 0 0 1 78 34.168v28.257a1.49 1.49 0 0 1-.98 1.403l-25.296 9.087a1.465 1.465 0 0 1-.493.085zm-1.137-8.494V49.502c0-.813.784-1.473 1.75-1.473s1.75.66 1.75 1.473v15.004c0 .815-.784 1.474-1.75 1.474s-1.75-.659-1.75-1.474z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/order-count.svg